.Checkbox {
  cursor: pointer;
  display: grid;
  grid: auto / auto;
  place-items: center;
  width: 24px;
  aspect-ratio: 1;
  border-radius: 7px;
  background-color: var(--control-background);
  transition: background-color 150ms;

  &.disabled {
    pointer-events: none;
    opacity: 0.2;
  }

  &[data-read-only="true"] {
    pointer-events: none;
    cursor: default;
  }

  input {
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
    pointer-events: none;
  }

  .CheckboxIndicator {
    display: block;
    width: 1rem;
    aspect-ratio: 1;
    border-radius: 3px;
    border: 1px solid var(--black);
    background-color: var(--white);
    transition: border-color 150ms;
  }

  &:has(input:focus-visible) {
    outline: 2px solid var(--focus);
    outline-offset: 2px;
  }

  &:has(input:checked) {
    --control-background: var(--primary);

    [data-slot="indicator"] {
      background-image: url("./checked.svg");
      background-repeat: no-repeat;
      background-size: 12px;
      background-position: top calc(50% + 0.5px) center;
      border-color: var(--primary);
    }
  }
}

.radio {
  .CheckboxIndicator {
    overflow: hidden;
    display: grid;
    place-items: center;
    position: relative;
    border-radius: 0.5rem;
    width: 1rem;
    aspect-ratio: 1;
    background-color: var(--white);

    &:after {
      display: block;
      aspect-ratio: 1;
      border-radius: 0.5rem;
      width: 0.6rem;
      content: "";
      background: var(--primary-1);
      transform: translateX(2rem);
      transition: transform 350ms;
    }
  }

  &:has(input:checked) .CheckboxIndicator {
    background-image: none;
    &:after {
      transform: none;
    }
  }
}
